export default {
	coordinates: {
		icon: 'map-marker',
		borderColor: '#FFFFFF',
		textColor: '#FFFFFF',
		backgroundColor: '#333333'
	},

	registroCamada: {
		icon: 'map-marker',
		borderColor: '#FFFFFF',
		textColor: '#FFFFFF',
		backgroundColor: '#FF0000'
	},

	inspecao: {
		icon: 'map-marker',
		borderColor: '#FFFFFF',
		textColor: '#FFFFFF',
		backgroundColor: '#FF0000'
	},

	getMarcadorCamada (estilo) {
		return {
			iconShape: 'marker',
			icon: estilo.marcador.icone,
			borderColor: 'rgba(255, 255, 255, 0.5)',
			borderWidth: 1,
			textColor: estilo.marcador.corIcone,
			backgroundColor: estilo.marcador.cor
		};
	}
};



// WEBPACK FOOTER //
// ./src/utils/markerStyles.js